import React, { useEffect } from 'react';
// import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createRoot } from 'react-dom/client'; // Import the createRoot method
import 'react-app-polyfill/ie11';

import { PersistGate } from 'redux-persist/integration/react';
import store, { persistor } from './store';
import { getAllProducts, refreshStore } from './actions';
import AppRoute from './routes';
import { initFunctions } from './utils';
// import LoadingOverlay from './components/features/loading-overlay';
// import AppRoute from './App';
import { BrowserRouter } from 'react-router-dom';

function Root() {
    initFunctions();
    store.dispatch(getAllProducts());

    useEffect(() => {
        if (store.getState().modal.current !== 2) {
            store.dispatch(refreshStore(2));
        }
    }, []);

    return (
        <Provider store={store}>
            <PersistGate persistor={persistor} >
                <BrowserRouter basename="/"> {/* Add the basename prop */}
                    <AppRoute />
                </BrowserRouter>
            </PersistGate>
        </Provider >
    );
}

const rootElement = document.getElementById('root');
const root = createRoot(rootElement); // Create a root instance
root.render(<Root />); // Render your app using createRoot
